export const Marquee = ({ items, fast = false, gold = false }) => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="marquee"
      className={`overflow-hidden border-y-[3px] border-[#0a0a0a] py-4 ${gold ? "bg-[#e5b83b]" : "bg-[#d96b43]"}`}
      style={gold ? {} : { transform: "rotate(-0.6deg) scale(1.02)" }}
    >
      <div className={`marquee-track ${fast ? "fast" : ""}`}>
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
                <span className={`font-script text-3xl sm:text-4xl ${i % 2 ? "text-[#f4f1ea]" : "text-[#0a0a0a]"}`} style={i % 2 ? { textShadow: "2.5px 2.5px 0 #0a0a0a" } : {}}>
                  {item}
                </span>
                <span className="mx-8 text-xl text-[#0a0a0a]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
